(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    


$(function(){
  //商品一覧に必要に応じてタグを追加
  add_tag_items();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
/* ヘッダースクロール追従時 ここから */
$(function(){
  let global_menu = $('#global_nav'),
      height_num = global_menu.outerHeight(true),
      position = global_menu.offset().top + height_num;

  $(window).on('scroll', function(){
    let padding_top_value = position < $(window).scrollTop() && window.matchMedia( '(min-width: 769px)' ).matches?
          height_num: '';

    $('#main_visual').css('padding-top', padding_top_value);
  });
});
/* ヘッダースクロール追従時 ここまで */




/* スライドショー ここから */

$('#main_visual_items .slick_items img').fadeIn(100);

$("#main_visual_items .slick_items").slick({
  fade: true,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
});

/* スライドショー ここまで */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    


$(function(){
  /*
  * 商品名の英日間にbrタグ追加
  */
  let origin_elem = $('#detail .js_prod_name'),
      origin_txt =  origin_elem.text();

  if(origin_txt.match(/【.*?】/) !== null){
    let txt_ja = origin_txt.replace(/【.*?】/, ''),
        txt_en = replace_space_from_txt(
          origin_txt.match(/【.*?】/)[0]
        );

    origin_elem.html(txt_ja + '<br>' + txt_en);
  }

  /*
  * 商品タグ追加
  */
  add_tag_items();
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-template"]) return;
  try {
    

$(function(){
  //商品一覧に必要に応じてタグを追加
  add_tag_items();

  //TOPのカテゴリ一覧を追加
  $('#js_top_cat_items').load('/ #top_cat_items', function(){

    // CATEGORY OF ITEMS 背景処理
    control_bg_top_cat_items();

    // カテゴリ名英語文字列に改行追加
    add_return_to_string();

    $("#top_cat_items .imgLiquidFill").imgLiquid();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_cat"] && !Shopify.designMode) return;
  try {
    
$(function(){
  // CATEGORY OF ITEMS 背景処理
  control_bg_top_cat_items();

  // カテゴリ名英語文字列に改行追加
  add_return_to_string();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_info"] && !Shopify.designMode) return;
  try {
    
$(function(){
  let cats = {};
  $.ajax({
    url: 'https://corp.seibon-gallery.jp/wp-json/wp/v2/info_cat',
    dataType: 'json',
    async: false,
    data: { 'data' : 'data' },
    success: function(json) {
      cats = json;
    }
  });

  $.getJSON( 'https://corp.seibon-gallery.jp/wp-json/wp/v2/info?per_page=3', function(results) {
    let html = '';

    $.each(results, function(i, item) {
      let date_data = new Date(item.date),
          year = date_data.getFullYear(),
          month = date_data.getMonth() + 1,
          day = date_data.getDate(),
          date = year + '.' + month + '.' + day,
          title = item.title.rendered,
          link = item.link,
          cat = $.grep(cats,
            function(elem, index) {
              return (elem.id == item.info_cat[0]);
            }
          );

      html += `
        <div class="post_item">
          <div class="post_date">${date}</div>
          <div class="post_cat">
      `

      if(cat.length > 0){
        html += `<span class="info_cat post_cat_inner">${cat[0].name}</span>`
      }

      html += `
          </div>
          <div class="post_ttl"><a href="${link}" class="post_url">${title}</a></div>
        </div>
      `;

    });

    if(html) $('#top_info .top_info_inner').append(html);

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_new"] && !Shopify.designMode) return;
  try {
    
/* スライドショー ここから */
//NEW ARRIVAL
$(function () {
  $("#top_new_arrival .slide_items").slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<div class="prev_arrow"><span><img src="//cdn.shopify.com/s/files/1/0437/9695/5295/t/11/assets/sl-arrow-left.svg?v=179505712574581821"></span></div>',
    nextArrow: '<div class="next_arrow"><span><img src="//cdn.shopify.com/s/files/1/0437/9695/5295/t/11/assets/sl-arrow-right.svg?v=18018011704936600799"></span></div>'
  });
});
/* スライドショー ここまで */

  } catch(e) { console.error(e); }
})();
})();
